import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import RakanBoxPage from './pages/RakanBoxPage';
import SideProjectsPage from './pages/SideProjectsPage';
import ContactPage from './pages/ContactPage';
import BookConsultationPage from './pages/BookConsultationPage';
import BarkarProjectsPage from './pages/BarkarProjectsPage';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/rakan-box" element={<RakanBoxPage />} />
            <Route path="/side-projects" element={<SideProjectsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/book-consultation" element={<BookConsultationPage />} />
            <Route path="/barkar-projects" element={<BarkarProjectsPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
